const rankCheckpoints = [
  1, 27, 53, 81, 114, 154, 200, 249, 301, 353, 402, 450, 495, 543, 600,
];

export const findCheckPoint = (points) =>
  rankCheckpoints?.filter((el) => el > points)[0];

// prettier-ignore
export const RANK_DESCRIPTIONS_BY_NAME = {
  en: {
    'Brigadier General':
      'Commands at the highest level, setting strategic goals and leading large formations.',
    'Captain': 'Commands units and drives strategic initiatives.',
    'Chief Master Sergeant':
      'Heads large units, enforces policies and standards.',
    'Chief Sergeant': 'Manages senior sergeants and upholds high standards.',
    'Colonel': 'Leads major operations and shapes strategic direction.',
    'Junior Lieutenant': 'Begins leadership roles and plans missions.',
    'Lieutenant': 'Executes complex strategies and leads teams.',
    'Lieutenant Colonel':
      'Manages large-scale initiatives and ensures performance.',
    'Major': 'Oversees significant operations and strategic planning.',
    'Master Sergeant':
      'Advises commanders and oversees operational efficiency.',
    'Senior Lieutenant': 'Leads a platoon and plans missions.',
    'Senior Master Sergeant':
      'Leads large sections, provides strategic advice.',
    'Senior Sergeant': 'Oversees sergeants and manages complex tasks.',
    'Sergeant': 'Leads a small team and ensures daily operations run smoothly.',
    'Staff Sergeant':
      'Manages advanced operations and higher responsibilities.',
  },
  ua: {
    'Бригадний генерал': 'Командує на найвищому рівні, ставить стратегічні цілі та керує великими формуваннями.',
    'Головний майстер сержант': 'Очолює великі підрозділи, впроваджує політики та стандарти.',
    'Головний сержант': 'Керує старшими сержантами та підтримує високі стандарти.',
    'Капітан': 'Командує підрозділами та керує стратегічними ініціативами.',
    'Лейтенант': 'Реалізовує складні стратегії та керує командами.',
    'Майор': 'Здійснює нагляд за важливими операціями та стратегічним плануванням.',
    'Майстер сержант': 'Консультує командирів і стежить за оперативною ефективністю.',
    'Молодший лейтенант': 'Починає виконувати лідерські ролі та планує місії.',
    'Полковник': 'Керує основними операціями та формує стратегічний напрямок.',
    'Підполковник': 'Керує масштабними ініціативами та забезпечує результативність.',
    'Сержант': 'Керує невеликою командою та забезпечує безперебійну роботу щоденних операцій.',
    'Старший лейтенант': 'Керує взводом та планує місії.',
    'Старший майстер сержант': 'Керує великими підрозділами, надає стратегічні консультації.',
    'Старший сержант':'Здійснює нагляд за сержантами та керує складними завданнями.',
    'Штаб-сержант': 'Керує складними операціями та виконує більш високі обов\'язки.',
  },
};
// prettier-enable
